<template>
  <a-date-picker
    v-model:value="model"
    :disabled="disabled"
    format="DD.MM.YYYY"
    :locale="locale"
    :placeholder="placeholder"
  >
    <template #suffixIcon>
      <slot name="suffixIcon"></slot>
    </template>
  </a-date-picker>
</template>

<script setup>
  /**
   * Компонент-фасад для компонента <a-date-picker/> из библиотеки ant-design-vue.
   * Его нужно использовать в коде компонентов вместо <a-date-picker/>.
   * 
   * Пример использования:
   * <date-picker-facade
   *   v-model="checkpoint.date"
   *   placeholder="Дата выполнения"
   *   :disabled="checkpoint.noMatter"
   * >
   *   <template #suffixIcon></template>
   * </date-picker-facade>
   */

  import locale from 'ant-design-vue/es/date-picker/locale/ru_RU';
  import { defineModel } from 'vue';

  const model = defineModel();

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  });
</script>

<style lang="scss" scoped>

</style>